import { styled } from '@acko-tech/building-blocks.ui.common';

export const CouponSuccessModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  top: -70px;
`;

export const GradientText = styled.div`
  background: linear-gradient(90.97deg, #6136d9 11.34%, #d331b8 77.76%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 2rem;
  font-weight: 700;
  line-height: 2.5rem;
  margin: 20px 0 0 0;
`;

export const GiftAnimation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 80px;
  width: 80px;
`;

export const ConfettiAnimation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 240px;
  width: 240px;
  top: 60%;
  left: 60%;
  transform: translate(-50%, -50%);
`;

export const TopConfettiAnimation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 240px;
  width: 100%;
  top: 0;
`;

export const BottomConfettiAnimation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 240px;
  width: 100%;
  top: 400px;
`;
